import { render, staticRenderFns } from "./AddDistribution.vue?vue&type=template&id=133b4295&scoped=true&"
import script from "./AddDistribution.vue?vue&type=script&lang=js&"
export * from "./AddDistribution.vue?vue&type=script&lang=js&"
import style0 from "./AddDistribution.vue?vue&type=style&index=0&id=133b4295&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "133b4295",
  null
  
)

export default component.exports